import { addDays, isPast, isToday } from 'date-fns';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { GoalNet } from '@sorare/core/src/atoms/icons/GoalNet';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineL } from '@sorare/core/src/atoms/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Root = styled(Horizontal)`
  padding: var(--double-unit);
  text-align: center;

  @media ${tabletAndAbove} {
    min-height: 0;
    padding: calc(10 * var(--unit)) var(--double-unit) var(--double-unit);
  }
`;

const messages = defineMessages({
  titleToday: {
    id: 'Rivals.EmptyState.title.today',
    defaultMessage: 'No matches today',
  },
  ctaToday: {
    id: 'Rivals.EmptyState.cta.today',
    defaultMessage: 'Go to Tomorrow',
  },
  titleFuture: {
    id: 'Rivals.EmptyState.title.future',
    defaultMessage: 'No matches',
  },
  ctaFuture: {
    id: 'Rivals.EmptyState.cta.future',
    defaultMessage: 'Go to next day',
  },
  titlePast: {
    id: 'Rivals.EmptyState.title.past',
    defaultMessage: 'No matches played',
  },
  ctaPast: {
    id: 'Rivals.EmptyState.cta.past',
    defaultMessage: 'Go back to Today',
  },
});

type Props = { date: Date; onClick: (newDate: Date) => void };
export const EmptyState = ({ date, onClick }: Props) => {
  const { formatMessage } = useIntl();

  let titleMessage = messages.titleFuture;
  let ctaMessage = messages.ctaFuture;
  let dateToNavigate = addDays(date, 1);

  if (isToday(date)) {
    titleMessage = messages.titleToday;
    ctaMessage = messages.ctaToday;
  } else if (isPast(date)) {
    titleMessage = messages.titlePast;
    ctaMessage = messages.ctaPast;
    dateToNavigate = new Date();
  }

  return (
    <Root center>
      <Vertical center gap={2}>
        <GoalNet width={80} height={80} color="var(--c-neutral-400)" />
        <Vertical gap={4}>
          <HeadlineL as="h2">{formatMessage(titleMessage)}</HeadlineL>
          <Button
            color="primary"
            size="medium"
            onClick={() => onClick(dateToNavigate)}
          >
            {formatMessage(ctaMessage)}
          </Button>
        </Vertical>
      </Vertical>
    </Root>
  );
};
